import {
  Box,
  Button,
  Checkbox,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import api from "../../../../API";
import { useSelector } from "react-redux";
// import _debounce from 'lodash/debounce';
import { MmmuType } from "./Task10ListPage";
import VieJsonDialog from "../../../admin/vie/VieJsonDialog";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { SearchBackDrop } from "../../../component/common/SearchBackDrop";

const initailData: MmmuType = {
  idx: -1,
  id: "",
  worker: "",
  work_date: "",
  work_yn: "",
  use_check: "",

  prc_worker:"",
  prc_date: "",
  prc_yn:"",

  isp_worker:"",
  isp_date: "",
  isp_yn:"",
  
  category: "",

  sub_code: "",

  source: "",
  difficulty: "",

  answer: "",

  translate_need: "",

  explanation_vi: "",
  question_vi: "",
  choice_vi_1: "",
  choice_vi_2: "",
  choice_vi_3: "",
  choice_vi_4: "",

  explanation_ko: "",
  question_ko: "",
  choice_ko_1: "",
  choice_ko_2: "",
  choice_ko_3: "",
  choice_ko_4: "",

  explanation_en: "",
  question_en: "",
  choice_en_1: "",
  choice_en_2: "",
  choice_en_3: "",
  choice_en_4: "",

};

export interface MmmuDetail {
  idx: number;
  id: string;
  id_sub: string;
  subfield: string;
  name: string;
  image_data: any;
  file_extension: string;
  file_size: number;
  width: number;
  height: number;
  mmmu_idx: number;
}

export interface BlobImage {
  name: string;
  type: string;
  data: Blob;
}


const Task10DetailDialog = (props: any) => {

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const [data, setData] = useState<any>(initailData);

  // /////////////////////////////////////////////////////////////////

  const [ttaData, setTtaData] = useState<any[] | null>(null);

  const [dataList, setDataList] = useState<{ idx: number; confirm_data: any }[]>([]);

  const handleUpdate = (idx: number, value: any) => {
    setDataList((prev:any) =>
      prev.map((item:any) =>
        item.idx === idx ? { ...item, confirm_data: value } : item
      )
    );
  };

  const saveTtaData = async (idx: string) => {
    const confirm_data = dataList.find((item:any) => item.idx === idx)!.confirm_data;
    console.log('Saved Data for idx :', confirm_data);

    const formData = new FormData();

    formData.append("email", email);

    formData.append("confirm_data", confirm_data);

    formData.append("idx", idx);

    await api.post("/vie-tta-update", formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})
  };

  // /////////////////////////////////////////////////////////////////

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [check_1, setCheck_1] = useState(false);
  const [check_2, setCheck_2] = useState(false);
  const [check_3, setCheck_3] = useState(false);
  const [check_4, setCheck_4] = useState(false);
  const [check_5, setCheck_5] = useState(false);
  const [check_6, setCheck_6] = useState(false);
  const [check_7, setCheck_7] = useState(false);
  const [check_8, setCheck_8] = useState(false);
  const [check_9, setCheck_9] = useState(false);
  const [check_10, setCheck_10] = useState(false);

  // const [detail, setDetail] = useState<MmmuDetail[]>([initailDetailData]);

  // const [images, setImages] = useState<string[] | null>(null);

  const [image_1, setImage_1] = useState<string | null>(null);
  const [image_2, setImage_2] = useState<string | null>(null);

  const [image_1_name, setImage_1_name] = useState<string | null>(null);
  const [image_2_name, setImage_2_name] = useState<string | null>(null);

  const [imageBlob_1, setImageBlob_1] = useState<BlobImage | null>(null);
  const [imageBlob_2, setImageBlob_2] = useState<BlobImage | null>(null);


  // const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let manager_role = auth.user.roles.some((obj:any) => ['VIE_PRC','VIE_MANAGER'].includes(obj.role));

  let isp_role = auth.user.roles.some((obj:any) => ['VIE_MANAGER'].includes(obj.role));

  const checkList = (check_num:number) => {
    if(check_num === 1){setCheck_1(!check_1)}
    if(check_num === 2){setCheck_2(!check_2)}
    if(check_num === 3){setCheck_3(!check_3)}
    if(check_num === 4){setCheck_4(!check_4)}
    if(check_num === 5){setCheck_5(!check_5)}
    if(check_num === 6){setCheck_6(!check_6)}
    if(check_num === 7){setCheck_7(!check_7)}
    if(check_num === 8){setCheck_8(!check_8)}
    if(check_num === 9){setCheck_9(!check_9)}
    if(check_num === 10){setCheck_10(!check_10)}
  }

  // const getAuths = async () => {
  //   var result = await api.get("/getAuths");
  //   setAuths(result.data.data);
  // };

  const ImageUploader = ({ setImage, setImageBlob }: { setImage: React.Dispatch<React.SetStateAction<string | null>>, setImageBlob: React.Dispatch<React.SetStateAction<BlobImage | null>> }) => {
    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;
      const file = files && files[0]; // 첫 번째 파일 가져오기
      
      if (file) {
        
        const reader = new FileReader();
        reader.onloadend = () => {
          const blob = new Blob([reader.result as ArrayBuffer], { type: file.type });
          setImageBlob({name:file.name,type:file.type,data:blob})
          const url = URL.createObjectURL(blob); // Blob에서 URL 생성
          setImage(url); // 이미지 URL을 상태에 설정

          // console.log('파일이름', file.name)
          // console.log('파일 타입', file.type)
        };
        reader.readAsArrayBuffer(file); // 파일을 ArrayBuffer로 읽기
      }
    };
  
    return (
      <input
        type="file"
        accept="image/*"
        onChange={handleImageChange} // 이미지 파일이 선택되었을 때 실행
      />
    );
  };

  const base64ToBlob = (base64Data:any, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(base64Data);
    const byteArrays:any = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray); 
    }
  
    return new Blob(byteArrays, { type: contentType });
  };

  const blobToBase64 = (file:any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        resolve(reader.result); // Base64로 인코딩된 파일 데이터
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const deleteImg = async (idx: number, subfield:string) => {

    const confirmDelete = window.confirm("Image "+subfield+"를 삭제하시겠습니까?");
    
    // 사용자가 '예'를 선택했을 때만 삭제 진행
    if (!confirmDelete) {
        return; // '아니오'를 선택하면 함수 종료
    }

    const formData = new FormData();

    formData.append("email", email);

    formData.append("idx", idx.toString());

    formData.append("subfield", subfield);

    await api.post("/vie-10-mmmuImgDelete",formData)
    .then((res:any) => { alert('이미지 삭제완료'); 
      if(subfield === '01'){
        setImage_1(null)
        setImage_1_name(null)
        setImageBlob_1(null)
      }

      if(subfield === '02'){
        setImage_2(null)
        setImage_2_name(null)
        setImageBlob_2(null)
      }
      
     })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})
  }

  const getDetail = useCallback(async (mmmu_idx: string) => {
    var result = await api.get("/mmmu-detail",{params:{mmmu_idx:mmmu_idx}});
    // console.log('image_data', result.data.datas[0].image_data);
    // setDetail(result.data.datas)
    
    if (result.data.datas.length > 0) {
      result.data.datas.forEach((detailData:MmmuDetail) => {
        console.log('image data ??? ' , detailData)
        
        if(detailData.subfield === "01"){
          const blob_1 = base64ToBlob(detailData.image_data, 'image/'+detailData.file_extension);
          const url = URL.createObjectURL(blob_1);
          setImage_1(url);
          setImage_1_name(detailData.name);
        }else if(detailData.subfield === "02"){
          const blob_2 = base64ToBlob(detailData.image_data, 'image/'+detailData.file_extension);
          const url = URL.createObjectURL(blob_2);
          setImage_2(url);
          setImage_2_name(detailData.name);
        }
        
      });
    }
    // console.log('urls',urls)
    // setImages(urls);


    // urls.forEach((url:any) => URL.revokeObjectURL(url)); // 모든 URL 해제

  },[]);


  const saveMmluData = async (translate:string) => {

    const formData = new FormData();

    if(email !== "go@gmail.com" && (data.answer === "None" || data.answer === "")){
      alert('Answer 을 선택하세요.')
      return;
    }

    if(email !== "go@gmail.com" && data.use_check === "None"){
      alert('체크결과 를 선택하세요.')
      return;
    }

    if(email !== "go@gmail.com" && (data.sub_code === "None" || data.sub_code === "" || data.sub_code === null)){
      alert('소분류주제코드 를 입력하세요.')
      return;
    }

    if(email !== "go@gmail.com" && (data.difficulty === "None" || data.difficulty === "" || data.difficulty === null)){
      alert('난이도 를 입력하세요.')
      return;
    }

    if(data.source === "None" || data.source === "" || data.source === null){
      alert('출처 를 입력하세요.')
      return;
    }

    if(email !== "vanvan511@naver.com" && email !== "buiminhthuy730@gmail.com" && email !== "go@gmail.com" && data.category === "None" && data.use_check !== "F"){
      alert('Category 를 선택하세요.')
      return;
    }


    if(email !== "go@gmail.com" && manager_role === true && data.prc_yn === 'None'){
      alert('가공결과 를 선택하세요.')
      return;
    }

    if(email !== "go@gmail.com" && isp_role === true && data.isp_yn === 'None'){
      alert('검수결과 를 선택하세요.')
      return;
    }

    if(translate === 'need'){
      formData.append("translate_need", 'Y');
    }


    setBackdrop(true)
    formData.append("email", email);

    formData.append("datas", JSON.stringify(data));

    if(imageBlob_1){
      const blobData_1 = await blobToBase64(imageBlob_1.data);
      formData.append("image_name_1", imageBlob_1.name);
      formData.append("image_type_1", imageBlob_1.type.replace('image/',''));
      formData.append("image_blob_1", JSON.stringify(blobData_1));
    }
    
    if(imageBlob_2){
      const blobData_2 = await blobToBase64(imageBlob_2.data);
      formData.append("image_name_2", imageBlob_2.name);
      formData.append("image_type_2", imageBlob_2.type.replace('image/',''));
      formData.append("image_blob_2", JSON.stringify(blobData_2));
    }
    

    if(manager_role !== true){
      let check_list = ""
      if(check_1){check_list+="1"}
      if(check_2){check_list+="2"}
      if(check_3){check_list+="3"}
      if(check_4){check_list+="4"}
      if(check_5){check_list+="5"}
      if(check_6){check_list+="6"}
      if(check_7){check_list+="7"}
      if(check_8){check_list+="8"}
      if(check_9){check_list+="9"}
      if(check_10){check_list+="10"}
  
      formData.append("checklist", check_list);
    }

    await api.post("/vie-10-mmmuUpdate",formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); props.updateAfter(); setBackdrop(false);})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  const openGuideWindow = () => {
    const imageUrl = `${process.env.PUBLIC_URL}/img/vie-task/Vie-MMMU.jpg`;

    window.open(imageUrl, '_blank');
  }

  // 경고 때문에 조치
  const getTtaData = useCallback(async (detail:any) => {

    api.get('/vie-tta-dataList',{params:{email:email,task:'10',task_idx:detail.idx}})
    .then((resp:any) => {setTtaData(resp.data.datas); console.log("결과", resp.data.datas)})
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  },[email])

  useEffect(() => {
    // getAuths();
    console.log('값 가져오기', props.rowDetail)
    setData(initailData);
    setImage_1(null)
    setImage_2(null)
    setImage_1_name(null)
    setImage_2_name(null)
    setImageBlob_1(null)
    setImageBlob_2(null)
    setData(props.rowDetail);
    // if(props.rowDetail !== undefined){
    //   getDetail(props.rowDetail.idx)
    // }
    // setTtaData([])
    // getTtaData(props.rowDetail)
  }, [props.rowDetail]);

  useEffect(() => {
  if (!props.rowDetail) return;
  getDetail(props.rowDetail.idx);
  getTtaData(props.rowDetail);
}, [props.rowDetail, getDetail, getTtaData]); // ← ① 또는 ②로 안정화

  useEffect(() => {
      // ttaData가 null이 아닐 때 초기 상태 설정
      if (ttaData) {
        setDataList(ttaData.map((tt) => ({ idx: tt.idx, confirm_data: tt.confirm_data || "" })));
      }
    }, [ttaData]);

  return (
    <Paper sx={{width:"100%", overflow: "auto", padding:"20px"}}>
      {data ? 
      <>
      <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>데이터 확인</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box>
        {backdrop && ( <SearchBackDrop/> )}
        <Box sx={{position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >

          {/* <Box display="flex" justifyContent="center"> */}
          <Box display="flex">

            <Box display="flex" sx={{marginLeft: "50px"}}>
              <Box sx={{width:"100%"}}>
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>idx</Box>
                  <Box sx={{fontSize:"14px", width:"130px"}}>{data.idx}</Box>
                </Box>
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>id</Box>
                  <Box sx={{fontSize:"14px", width:"130px"}}>{data.id}</Box>
                </Box>
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>작업워커</Box>
                  <Box sx={{fontSize:"14px", width:"190px"}}>{data.worker}</Box>

                  <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>작업상태</Box>
                  <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                      backgroundColor: (data.work_yn === "Y" ? "#27cc2f" : "#bbb"), color:"#fff"
                  }}>
                    {(data.work_yn === "Y" ? "작업완료" : "미작업")}
                  </Box>

                  <Box sx={{fontSize:"14px",fontWeight:700, width:"120px", marginLeft:"32px"}}>번역검토필요</Box>
                  <Box sx={{fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                      backgroundColor: (data.translate_need === "Y" ? "#9c27b0" : (data.translate_need === "None" ? "#bbb" : "#27cc2f")), color:"#fff"
                  }}>
                    {(data.translate_need === "Y" ? "검토필요" : (data.translate_need === "None" ? "미작업" : "검토완료"))}
                  </Box>
                </Box>
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>업데이트시간</Box>
                  <Box sx={{fontSize:"14px", width:"190px"}}>{data.work_date}</Box>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>체크결과</Box>
                  <Select id="use_check" value={data.use_check} onChange={(e) => {setData({ ...data, use_check: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                    <MenuItem dense value={"T"}>T - 사용가능</MenuItem>
                    <MenuItem dense value={"C"}>C - 내용수정</MenuItem>
                    <MenuItem dense value={"F"}>F - 사용불가</MenuItem>
                  </Select>
                </Box>
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>출처 - URL</Box>
                  <Box sx={{fontSize:"14px", width:"500px"}}>
                    <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                              value={data.source} onChange={(e) => {setData({ ...data, source: e.target.value });}}
                    // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                      InputProps={{
                        style: {width: "500px", height:"30px", fontSize:"14px"},
                        inputProps: { 
                          spellCheck: "false" // spellcheck를 false로 설정
                        },
                      }}
                    /></Box>
                  <Button variant="contained" size="small" sx={{fontWeight:700, margin:"8px 16px 8px 8px"}} onClick={() => window.open(data.source, '_blank')}>
                    open URL
                  </Button>
                </Box>
                {manager_role ? 
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>가공시간</Box>
                  <Box sx={{fontSize:"14px", width:"190px"}}>{data.prc_date}</Box>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>가공결과</Box>
                  <Select id="prc_yn" value={data.prc_yn} onChange={(e) => {setData({ ...data, prc_yn: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                    <MenuItem dense value={"Y"}>가공완료</MenuItem>
                    <MenuItem dense value={"N"}>가공부적합</MenuItem>
                    <MenuItem dense value={"None"}>-</MenuItem>
                  </Select>
                </Box>
                :""}
                {isp_role && data.prc_yn === 'Y' ? 
                  <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"104px"}}>검수시간</Box>
                    <Box sx={{fontSize:"14px", width:"190px"}}>{data.isp_date}</Box>
                    <Box sx={{fontSize:"14px",fontWeight:700, width:"80px"}}>검수결과</Box>
                    <Select id="isp_yn" value={data.isp_yn} onChange={(e) => {setData({ ...data, isp_yn: e.target.value });}} sx={{color:"green",width:"180px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                      <MenuItem dense value={"Y"}>검수완료</MenuItem>
                      <MenuItem dense value={"N"}>검수부적합</MenuItem>
                      <MenuItem dense value={"None"}>-</MenuItem>
                    </Select>
                  </Box>
                :<></>}
                <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                  <Box sx={{fontSize:"14px",fontWeight:700, width:"96px"}}>Category</Box>
                  <Select id="category" value={data.category} onChange={(e) => {setData({ ...data, category: e.target.value });}} sx={{color:"green",width:"250px",height: "35px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                    <MenuItem dense value={"사회/정치/산업"}>사회/정치/산업</MenuItem>
                    <MenuItem dense value={"건강/의학"}>건강/의학</MenuItem>
                    <MenuItem dense value={"날씨/자연/동식물"}>날씨/자연/동식물</MenuItem>
                    <MenuItem dense value={"음식/일상생활"}>음식/일상생활</MenuItem>
                    <MenuItem dense value={"IT/과학"}>IT/과학</MenuItem>
                    <MenuItem dense value={"역사/문화/예술/공예/의상"}>역사/문화/예술/공예/의상</MenuItem>
                    <MenuItem dense value={"일반상식/기타"}>일반상식/기타</MenuItem>
                  </Select>
                  <Button variant="contained" size="small" color="secondary" sx={{fontWeight:700, margin:"8px 16px 8px 250px"}} onClick={() => openGuideWindow()}>
                    OPEN GUIDE
                  </Button>
                  {manager_role ? 
                  <Button variant="contained" size="small" sx={{fontWeight:700, margin:"8px 16px 8px 200px", backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                    OPEN JSON
                  </Button>
                  :""}
                  {openJsonDialog ? <VieJsonDialog task={"10"} idx={data.idx} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
            
                </Box>
              </Box>
            </Box>
        
          {/* </form> */}
          </Box>

          

        </Box>

        {/* TTA */}
          <Box>
            {ttaData !== null && dataList && ttaData.map((tt:any,index:number) => 
              <Box key={tt.idx+index} sx={{border:"3px solid #498ad5"}}>
                <Box display="flex" justifyContent="center" sx={{alignItems:"center"}}>
                  <Box sx={{width:"200px",fontWeight:600,fontSize:"20px", marginRight:"6px", textAlign:"center"}}>{tt.desc}</Box>
                  <textarea defaultValue={tt.err_data} style={{width:"600px", height:"20px", fontSize:"16px", padding:"2px"}} />
                </Box>
                <Box display="flex" justifyContent="center" sx={{alignItems:"center"}}>
                  <Box sx={{width:"200px",fontWeight:600,fontSize:"20px", marginRight:"6px", textAlign:"center"}}>소명사유</Box>
                  {dataList.find((item:any) => item.idx === tt.idx) !== undefined &&
                    <textarea value={dataList.find((item:any) => item.idx === tt.idx)!.confirm_data || ""}
                    onChange={(e) => handleUpdate(tt.idx, e.target.value)}
                      style={{
                        width: "600px",
                        height: "20px",
                        fontSize: "16px",
                        padding: "2px",
                      }}
                    />
                  }
                  <Button
                    variant="contained"
                    sx={{ fontWeight: 700, margin: "8px 16px" }}
                    onClick={() => saveTtaData(tt.idx)}
                  >
                    저장
                  </Button>
                </Box>
              </Box>
            )}
          </Box>

        {/* TTA */}

        <Box sx={{height:"100%", overflow:"auto", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
          <Box display="flex">

          <Box>
            <Box display="flex" justifyContent="center" sx={{textAlign:"center"}}>
              <Box sx={{marginLeft:"32px", fontSize:"24px", paddingTop:"8px", fontWeight:700}}>소분류주제코드</Box>
                <Box sx={{marginLeft:"16px",fontSize:"14px", width:"90px"}}>
                  <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                            value={data.sub_code} onChange={(e) => {setData({ ...data, sub_code: e.target.value });}}
                  // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                    InputProps={{
                      style: {width: "90px", height:"30px", fontSize:"14px"},
                      inputProps: { 
                        spellCheck: "false" // spellcheck를 false로 설정
                      },
                    }}
                  />
                </Box>
            </Box>
            
            <Box display="flex" justifyContent="center" sx={{textAlign:"center"}}>
              <Box sx={{marginLeft:"32px", fontSize:"36px", paddingTop:"8px", fontWeight:700}}>난이도</Box>
              <Select id="answer" value={data.difficulty} onChange={(e) => {setData({ ...data, difficulty: e.target.value });}} sx={{color:"green",width:"76px",height: "35px", marginLeft: "8px", marginTop: "8px", border:"2px solid #498ad5", borderRadius:"4px"}}>
                <MenuItem dense value={"easy"}>하(easy)</MenuItem>
                <MenuItem dense value={"medium"}>중(medium)</MenuItem>
                <MenuItem dense value={"hard"}>상(hard)</MenuItem>
              </Select>
            </Box>

            <Box display="flex" justifyContent="center" sx={{textAlign:"center"}}>
              <Box sx={{marginLeft:"32px", fontSize:"36px", paddingTop:"8px", color:"#60ad50", fontWeight:700}}><b style={{color:"#000"}}>ANSWER : </b>[{data.answer}]</Box>
              <Select id="answer" value={data.answer} onChange={(e) => {setData({ ...data, answer: e.target.value });}} sx={{color:"green",width:"76px",height: "35px", marginLeft: "8px", marginTop: "8px", border:"2px solid #498ad5", borderRadius:"4px"}}>
                <MenuItem dense value={"A"}>A</MenuItem>
                <MenuItem dense value={"B"}>B</MenuItem>
                <MenuItem dense value={"C"}>C</MenuItem>
                <MenuItem dense value={"D"}>D</MenuItem>
                <MenuItem dense value={"확인필요"}>확인필요</MenuItem>
              </Select>
            </Box>

            <Box sx={{textAlign:"center", marginTop:"2px", background: "linear-gradient(to right, #e6e6e6 30%, #deebfa 70%)"}}>
              {/* {detail.length > 0 ? detail.map((d:MmmuDetail, index:number) =>  */}
                <Box>
                  <Box sx={{padding: "8px 8px 0px 8px", fontSize: "16px", fontWeight: 700}}>Image 1
                    {email === 'go@gmail.com' && 
                    <Button variant="contained" size="small" sx={{minWidth:"42px",fontWeight:700, marginLeft:"16px", backgroundColor:"red", borderRadius:"42px"}}
                        onClick={() => {
                          deleteImg(data.idx , '01')
                        }}
                      >
                        <DeleteForeverIcon />
                    </Button>
                    }
                  </Box>
                  <Box
                    sx={{
                      width: "410px",
                      height: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "8px",
                      backgroundColor: "#fff",
                      border: "3px solid #1976d2",
                      margin: "8px"
                    }}
                  >
                      {(image_1 !== null) ? 
                      <Box>
                      <img src={image_1} alt={""} width={"410px"} height={"282px"} />
                      <Box>{image_1_name}</Box>
                      </Box>
                      : <ImageUploader setImage={setImage_1} setImageBlob={setImageBlob_1} /> }
                      {/* <img src={images[0]} alt={""} width={"250px"} height={"250px"} /> */}
                    
                  </Box>
                </Box>
                <Box>
                  <Box sx={{padding: "8px 8px 0px 8px", fontSize: "16px", fontWeight: 700}}>Image 2
                    {email === 'go@gmail.com' && 
                    <Button variant="contained" size="small" sx={{minWidth:"42px",fontWeight:700, marginLeft:"16px", backgroundColor:"red", borderRadius:"42px"}}
                        onClick={() => {
                          deleteImg(data.idx , '02')
                        }}
                      >
                        <DeleteForeverIcon />
                    </Button>
                    }
                  </Box>
                  <Box
                    sx={{
                      width: "410px",
                      height: "300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "8px",
                      backgroundColor: "#fff",
                      border: "3px solid #1976d2",
                      margin: "8px"
                    }}
                  >
                      {(image_2 !== null) ? 
                      <Box>
                      <img src={image_2} alt={""} width={"410px"} height={"282px"} />
                      <Box>{image_2_name}</Box>
                      </Box>
                      : <ImageUploader setImage={setImage_2} setImageBlob={setImageBlob_2} /> }
                      {/* <img src={images[0]} alt={""} width={"250px"} height={"250px"} /> */}
                    
                  </Box>
                </Box>
              {/* ):""} */}
            </Box>

          </Box>

          <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
            <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea value={data.question_en || ""} onChange={(e) => {setData({ ...data, question_en: e.target.value });}} style={{width:"410px",minHeight:"120px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                      
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Explanation(추가설명)</Box>
                      <Box><textarea value={data.explanation_en || ""} onChange={(e) => {setData({ ...data, explanation_en: e.target.value });}} style={{width:"410px",minHeight:"312px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "A" ? "red" : "#000")}}>A</Box>
                    <Box><textarea value={data.choice_en_1 || ""} onChange={(e) => {setData({ ...data, choice_en_1: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "B" ? "red" : "#000")}}>B</Box>
                  <Box><textarea value={data.choice_en_2 || ""} onChange={(e) => {setData({ ...data, choice_en_2: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea value={data.choice_en_3 || ""} onChange={(e) => {setData({ ...data, choice_en_3: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea value={data.choice_en_4 || ""} onChange={(e) => {setData({ ...data, choice_en_4: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>VI</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea spellCheck="false" value={data.question_vi || ""} onChange={(e) => {setData({ ...data, question_vi: e.target.value });}} style={{width:"410px",minHeight:"120px", fontSize:"18px",padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Explanation(추가설명)</Box>
                      <Box><textarea spellCheck="false" value={data.explanation_vi || ""} onChange={(e) => {setData({ ...data, explanation_vi: e.target.value });}} style={{width:"410px",minHeight:"312px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "A" ? "red" : "#000")}}>A</Box>
                    <Box><textarea spellCheck="false" value={data.choice_vi_1 || ""} onChange={(e) => {setData({ ...data, choice_vi_1: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "B" ? "red" : "#000")}}>B</Box>
                    <Box><textarea spellCheck="false" value={data.choice_vi_2 || ""} onChange={(e) => {setData({ ...data, choice_vi_2: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea spellCheck="false" value={data.choice_vi_3 || ""} onChange={(e) => {setData({ ...data, choice_vi_3: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea spellCheck="false" value={data.choice_vi_4 || ""} onChange={(e) => {setData({ ...data, choice_vi_4: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"18px", fontWeight:600,padding:"2px", fontFamily: "Times New Roman, serif"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{padding:"4px", marginRight:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea value={data.question_ko || ""} onChange={(e) => {setData({ ...data, question_ko: e.target.value });}} style={{width:"410px",minHeight:"120px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Explanation(추가설명)</Box>
                      <Box><textarea value={data.explanation_ko || ""} onChange={(e) => {setData({ ...data, explanation_ko: e.target.value });}} style={{width:"410px",minHeight:"312px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                      
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "A" ? "red" : "#000")}}>A</Box>
                  <Box><textarea value={data.choice_ko_1 || ""} onChange={(e) => {setData({ ...data, choice_ko_1: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "B" ? "red" : "#000")}}>B</Box>
                  <Box><textarea value={data.choice_ko_2 || ""} onChange={(e) => {setData({ ...data, choice_ko_2: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea value={data.choice_ko_3 || ""} onChange={(e) => {setData({ ...data, choice_ko_3: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"16px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea value={data.choice_ko_4 || ""} onChange={(e) => {setData({ ...data, choice_ko_4: e.target.value });}} style={{width:"372px",minHeight:"40px", fontSize:"16px", fontWeight:600,padding:"2px"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            
          </Box>
          {(manager_role !== true && props.createVie !== 'true') ? 
          <Box sx={{border:"2px solid #4539ca", backgroundColor:"#fff", width:"600px", margin:"12px 84px 12px auto"}}>
            <Box sx={{fontSize:"14px",fontWeight:700, margin:"4px", width:"102px"}}>체크리스트</Box>
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(1)} checked={check_1}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>1. 원시데이터와 환경정보(메타정보)의 내용이 일치하는가?</Box></Box>     
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(2)} checked={check_2}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>2. 민감한 이슈(정치), 이메일 연락처, 개인고유식별번호 등의 포함 여부 확인 하였는가?</Box></Box>     
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(3)} checked={check_3}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>3. 무분별한 비난 또는 혐오적인 내용의 포함 여부 확인하였는가?</Box></Box>
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(4)} checked={check_4}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>4. 선정적인 내용 또는 상업적 목적의 내용은 제외되었는가?</Box></Box>
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(5)} checked={check_5}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>5. 오타나 문법 오류 등은 수정되었는가?</Box></Box>     
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(6)} checked={check_6}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>6. 저작권 침해 가능성 여부는 확인하였는가?</Box></Box>      
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(7)} checked={check_7}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>7. 텍스트 내용에 대한 주제분류는 적합하게 되었는가?</Box></Box> 
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(8)} checked={check_8}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>8. 불필요한 기호나 띄어쓰기, 이모티콘 등은 제거되었는가?</Box></Box> 
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(9)} checked={check_9}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>9. 번역된 부분에 해당언어로 번역이 잘 되었는가?</Box></Box> 
            <Box display="flex"><Checkbox sx={{alignSelf:"center"}} onChange={()=>checkList(10)} checked={check_10}/><Box sx={{alignSelf: "center", fontSize:"small", fontWeight:600, paddingRight:"20px"}}>10. 베트남 문화와 규범에 올바른 정보인가?</Box></Box> 
          </Box>
          :<></>}
        </Box>

      </Box>
      <Box display="flex" justifyContent="right" sx={{margin:"20px"}}>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            saveMmluData('need');
          }}
        >
          SAVE (번역검토필요)
        </Button>
        <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            saveMmluData('ok');
          }}
        >
          {manager_role ? "SAVE(검수)" : "SAVE"}
        </Button>
      </Box>
      </> : "데이터가 없습니다."}
      
    </Paper>
  );
};

export default Task10DetailDialog;
